import { IPeriodicidade } from "../interfaces/IPeriodicidade";
import api from "./Api";

class PeriodicidadeService {
    async obterTodos() :Promise<IPeriodicidade[]> {
        try {
            const { data: result } = await api.get<IPeriodicidade[]>('Periodicidade');

            return result;
        } catch (error) {	
            return [];
        }
    }
}

export default new PeriodicidadeService();